import lodash from "lodash";
import { callRegisterAttachment, callRegisterPersonAttachment } from "./register.section";

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refPersonType"].includes(field?.key);
            },
            inputPropField: ({ data, modelRef }) => {
                return {
                    "onUpdate:value": value => {
                        modelRef.refPersonType = value;
                        if (value?.key === "1") {
                            modelRef.refDocumentTypePerson = null;
                            data.useForm.clearValidate("idCard");
                        }

                        let promise = Promise.resolve([]);
                        if (value?.key === "1") {
                            promise = callRegisterAttachment({});
                        } else if (value?.key === "2") {
                            promise = callRegisterPersonAttachment({});
                        }
                        promise.then(items => {
                            items = items.map(item => ({ documentName: item.value, attribute: lodash.cloneDeep(item.attribute) }));
                            Promise.resolve()
                                .then(() => modelRef.attachments.splice(0, modelRef.attachments.length))
                                .then(() => modelRef.attachments.push(...items));
                        });
                    }
                };
            }
        },
        {
            check: ({ field }) => {
                return ["registerDate", "refDepartmentRegister.nameEn", "addresses.0.refAddressType", "addresses.1.refAddressType"].includes(
                    field?.key
                );
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["username"].includes(field?.key);
            },
            inputPropField: ({ modelRef }) => {
                return {
                    "onUpdate:value": value => {
                        modelRef.username = value;
                        modelRef.email = value;
                    }
                };
            }
        },
        {
            check: ({ field }) => {
                return ["buttonCheckIdCard"].includes(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refCompanyType",
                    "companyNameTh",
                    "companyNameEn",
                    // "addresses.0.tel",
                    // "addresses.0.fax",
                    // "addresses.1.tel",
                    // "addresses.1.fax"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["1"].includes(modelRef.refPersonType?.key);
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refDocumentTypePerson",
                    "refIssuedBy",
                    "outDate",
                    "expireDate",
                    "birthDate",
                    "refNationality",
                    "refRace",
                    "refReligion",
                    "refGender",
                    "refTitle",
                    "firstNameTh",
                    "firstNameEn",
                    "middleNameTh",
                    "middleNameEn",
                    "lastNameTh",
                    "lastNameEn",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2"].includes(modelRef.refPersonType?.key);
            }
        }
    ];
};
